import { Schema } from 'rsuite'

const { StringType, NumberType } = Schema.Types

export default Schema.Model({
  address: StringType().isRequired('Пожалуйста введите адрес магазина!'),
  minOrderCost: NumberType('Введите число').isInteger(
    'Пожалуйста, введите целое число!'
  ),
  xid: StringType().isRequired('Укажите ID в ТУС'),
  city_id: StringType().isRequired('Пожалуйста выберите город!')
})
